import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, DoCheck, OnChanges, ChangeDetectorRef } from "@angular/core";
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import {IMyDefaultMonth, INgxMyDpOptions } from '@mksasi/ngx-mydatepicker';
import { ValidationService } from '../../../validators/validation.service';
import { AppService } from "src/app/services/services";

@Component({
    selector: 'nri-app-nominee-info',
    templateUrl: './nominee-info.component.html',
    styleUrls: ['./nominee-info.component.scss']
})

export class NomineeeInfoComponent implements  DoCheck, OnInit{
    @Input() data: any;
    @Input() indexvalue: any;
    @Input() nomineeGetData: any;
    @Output() shareValue = new EventEmitter();
    @Output() nomineeAdd = new EventEmitter();
    @Output() nomineeDelete = new EventEmitter();
    @Output() nomineeFormValid = new EventEmitter();
    changelog: string[] = [];
    countryCode: any;
    countryList: any;
    docTypeList: any;
    guardian: boolean = false;
    // 'Y' = minor (DOB + guardian shown), 'N' = major. Each nominee instance
    // owns its own copy, so nominees stay independent of one another.
    isMinor: string = 'N';
    majorDate: any;
    nomineeDOB: any;
    totalShare: any = 0;
    delNominee: boolean = true;
    guardianGetData: any = {};
    codeKeyword = 'TeleCode';
    countryCodeError: boolean;
    nomineeIDs:any = [
        {value:"A",name:"Aadhaar"},
        {value:"P",name:"PAN"},
        {value:"VP",name:"Valid Passport"},
        {value:"DL",name:"Driving License"},
        // {value:"VI",name:"Voter ID"},
        // {value:"N",name:"No Document"}
    ]
    // Mandatory: name and relationship. DOB is mandatory only while the nominee
    // is a minor - that validator is added and removed by minorChange().
    // Everything else is optional per the regulatory field matrix.
    nomineeForm:any = this.formBuilder.group({
        'NomineeFirstName': ['', [Validators.required, this.noWhitespaceValidator]],
        'NomineeLastName': ['', [Validators.required, this.noWhitespaceValidator]],
        'NomineeDOB': [''],
        'NomineeRelationship': ['', Validators.required],
        // 'NomineeCountryCode': ['',Validators.required],
        'NomineeMobile': ['', [Validators.minLength(7)]],
        'NomineeEmail':['', null, ValidationService.emailValidator],
        'NomineeIDType': [''],
        'NomineeProofID': [''],
        'NomineeShare': [''],
        'IsMinor': ['N'],
        'IsGuardian': [this.guardian]
    });
    nomineeList: any;
    nomineeValue: any = {};
    options: INgxMyDpOptions = {
        dateFormat: 'dd/mm/yyyy',
    };
    nominee1De2:boolean = false;
    nominee1Del:boolean = false;
    constructor(public formBuilder: FormBuilder, public _http: AppService, private cdRef: ChangeDetectorRef){
        this.countryList = this._http.countryList;
    }

    ngOnInit(){
        this.setDobOptions();

        this._http.getMasters().subscribe(data=>{
            if(data && data.DocumentTypeList){
                this.docTypeList  = data.DocumentTypeList;
                this._http.getStatus().subscribe(d=>{
                  
                    this.docTypeList = data.DocumentTypeList.filter((e:any)=>{
                      return !e.OCI
                    })
                  
                })
            }
            if(data && data.NomineeList){
              this.nomineeList = data.NomineeList
            }
          });

        this.onNomineeFormValueChange();
        if(this.nomineeGetData && this.nomineeGetData.NomineeInfoId){
            // A major nominee has no date of birth, so only parse one when the
            // saved record actually carries it.
            let dob:any = this.parseSavedDate(this.nomineeGetData.DOB);
            // A saved nominee is a minor exactly when a guardian was recorded.
            this.isMinor = this.nomineeGetData.IsGuardian ? 'Y' : 'N';
            this.nomineeForm.patchValue({
                'NomineeFirstName': this.nomineeGetData.NomineeFirstName,
                'NomineeLastName': this.nomineeGetData.NomineeLastName,
                'NomineeDOB': dob,
                 "NomineeMobile": this.nomineeGetData.NomineeMobile,
                // "NomineeCountryCode" :this.nomineeGetData.NomineeCountryCode,
                "NomineeEmail": this.nomineeGetData.NomineeEmail,
                'NomineeRelationship': this.nomineeGetData.NomineeRelation,
                'NomineeShare': this.nomineeGetData.Share,
                'IsMinor': this.isMinor,
                'IsGuardian': this.nomineeGetData.IsGuardian,
                'NomineeIDType':this.nomineeGetData.NomineeIdProof,
                'NomineeProofID':this.nomineeGetData.NomineeIdProofNumber
            });
            this.setDobOptions();
            this.applyMinorValidators();
             this.countryCode = this.nomineeGetData.NomineeCountryCode;
            if (this.countryCode) {
                this.nomineeValue.NomineeCountryCode = this.countryCode;
                let param = {
                    index: this.indexvalue + 1,
                    status: true,
                    data: this.nomineeValue
                }
                this.nomineeFormValid.emit(param);
            }
            if(this.nomineeGetData.IsGuardian){
                this.guardian = true;
                this.guardianGetData.GuardianFirstName = this.nomineeGetData.GuardianFirstName;
                this.guardianGetData.GuardianLastName = this.nomineeGetData.GuardianLastName;
                this.guardianGetData.GuardianDOB = this.nomineeGetData.GuardianDOB;
               this.guardianGetData.GuardianMobile = this.nomineeGetData.GuardianMobile ?this.nomineeGetData.GuardianMobile :'' ;
                this.guardianGetData.GuardianCountryCode =this.nomineeGetData.GuardianCountryCode?.TeleCode ?this.nomineeGetData.GuardianCountryCode?.TeleCode: this.nomineeGetData.GuardianCountryCode ? this.nomineeGetData.GuardianCountryCode : '';
                this.guardianGetData.GuardianEmail = this.nomineeGetData.GuardianEmail ?this.nomineeGetData.GuardianEmail :'';
                this.guardianGetData.GuardianRelationship = this.nomineeGetData.GuardianRelation;
                this.guardianGetData.GuardianIdProof = this.nomineeGetData.GuardianIdProof;
                this.guardianGetData.GuardianIdProofNumber = this.nomineeGetData.GuardianIdProofNumber;
            }
        }
    }

    ngDoCheck() {
        if(this.data.shareValue){
            this.nomineeForm.controls.NomineeShare.setValue(this.data.shareValue, {emitEvent: false});
            this.totalShare = this.data.totalShare;
        }
        this.data.shareValue = null;
        this.data.totalShare = null;
    }

    openCalendarAndDetectChanges(dp: any) {
        dp.openCalendar();
        this.cdRef.detectChanges();
      }


    onNomineeFormValueChange(){
        this.nomineeForm.valueChanges.subscribe( (value:any) => {
            // if(this.nomineeForm.valid){
                this.nomineeValue.NomineeFirstName = this.nomineeForm.value.NomineeFirstName;
                this.nomineeValue.NomineeLastName = this.nomineeForm.value.NomineeLastName;
                this.nomineeValue.NomineeDOB = this.nomineeForm.value.NomineeDOB;
                  this.nomineeValue.NomineeMobile = this.nomineeForm.value.NomineeMobile ?this.nomineeForm.value.NomineeMobile :'' ,
                this.nomineeValue.NomineeCountryCode = this.countryCode ? this.countryCode : this.countryCode?.TeleCode ? this.countryCode?.TeleCode : '',
                this.nomineeValue.NomineeEmail = this.nomineeForm.value.NomineeEmail ?this.nomineeForm.value.NomineeEmail :'' ,
                this.nomineeValue.NomineeRelationship = this.nomineeForm.value.NomineeRelationship;
                this.nomineeValue.NomineeShare = this.nomineeForm.value.NomineeShare;
                this.nomineeValue.IsMinor = this.nomineeForm.value.IsMinor;
                this.nomineeValue.IsGuardian = this.nomineeForm.value.IsGuardian;
                this.nomineeValue.Idproof = this.nomineeForm.value.NomineeIDType;
                this.nomineeValue.IdNum = this.nomineeForm.value.NomineeProofID;
                let param = {
                    index: this.indexvalue + 1,
                    status: true,
                    data: this.nomineeValue
                }
                this.nomineeFormValid.emit(param)
            // }else{
            //     let param = {
            //         index: this.indexvalue + 1,
            //         status: false,
            //         data: ''
            //     }
            //     this.nomineeFormValid.emit(param)
            // }
        });
    }

    guardianData(event:any){
        if(event.status){
            this.nomineeValue.GuardianFirstName = event.data.GuardianFirstName;
            this.nomineeValue.GuardianLastName = event.data.GuardianLastName;
            this.nomineeValue.GuardianMobile = event.data.GuardianMobile ?event.data.GuardianMobile :'' ;
            this.nomineeValue.GuardianCountryCode =event.data.GuardianCountryCode.TeleCode ?event.data.GuardianCountryCode.TeleCode : event.data.GuardianCountryCode ? event.data.GuardianCountryCode:'';
            this.nomineeValue.GuardianEmail = event.data.GuardianEmail ?event.data.GuardianEmail :'';
            this.nomineeValue.GuardianIdProof =event.data.GuardianIdProof ?event.data.GuardianIdProof :'';
            this.nomineeValue.GuardianIdProofNumber = event.data.GuardianIdProofNumber ?event.data.GuardianIdProofNumber :'';
            // Guardian date of birth is no longer collected, but the key is kept
            // so the saved payload keeps its existing shape.
            this.nomineeValue.GuardianDOB = '';
            this.nomineeValue.GuardianRelationship = event.data.GuardianRelationship;
            if(this.nomineeForm.valid){
                let param = {
                    status: true,
                    data: this.nomineeValue
                }
                this.nomineeFormValid.emit(param);
            }
        }else{
            this.clearGuardianValues();
            let param = {
                status: false,
                data: ''
            }
            this.nomineeFormValid.emit(param);
        }
    }

    // The date itself no longer decides whether the nominee is a minor - the
    // explicit Is Nominee a Minor? answer does. This just records the value.
    onDateChanged(event:any){
        this.nomineeDOB = event.formatted;
    }

    // Called when the user answers Is Nominee a Minor?
    // Minor  -> date of birth is shown and becomes mandatory, guardian appears.
    // Major  -> date of birth is hidden and cleared, guardian is hidden and wiped.
    minorChange(){
        this.isMinor = this.nomineeForm.value.IsMinor;
        if(this.isMinor === 'Y'){
            this.guardian = true;
            this.nomineeForm.controls.IsGuardian.setValue(true);
        }else{
            this.guardian = false;
            this.nomineeForm.controls.IsGuardian.setValue(false);
            this.nomineeForm.controls.NomineeDOB.setValue('');
            this.nomineeDOB = '';
            this.clearGuardianValues();
        }
        this.setDobOptions();
        this.applyMinorValidators();
    }

    // Restricts the DOB calendar to future-proof "today" for a major, and to
    // strictly-under-18 (i.e. after today - 18 years) for a minor.
    setDobOptions(){
        const d: Date = new Date();
        if(this.isMinor === 'Y'){
            const minAdultDate: Date = new Date(d.getFullYear() - 18, d.getMonth(), d.getDate());
            this.options = {
                dateFormat: 'dd/mm/yyyy',
                showTodayBtn: false,
                disableSince: { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() + 1 },
                disableUntil: { year: minAdultDate.getFullYear(), month: minAdultDate.getMonth() + 1, day: minAdultDate.getDate() }
            }
        }else{
            this.options = {
                dateFormat: 'dd/mm/yyyy',
                showTodayBtn: false,
                disableSince: { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() + 1 }
            }
        }
    }

    // Date of birth is only a required field while the nominee is a minor.
    applyMinorValidators(){
        const dob = this.nomineeForm.controls.NomineeDOB;
        if(this.isMinor === 'Y'){
            dob.setValidators([Validators.required]);
        }else{
            dob.clearValidators();
        }
        dob.updateValueAndValidity({ emitEvent: false });
    }

    clearGuardianValues(){
        this.nomineeValue.GuardianFirstName = '';
        this.nomineeValue.GuardianLastName = '';
        this.nomineeValue.GuardianDOB = '';
        this.nomineeValue.GuardianRelationship = '';
        this.nomineeValue.GuardianMobile = '';
        this.nomineeValue.GuardianCountryCode = '';
        this.nomineeValue.GuardianEmail = '';
        this.nomineeValue.GuardianIdProof = '';
        this.nomineeValue.GuardianIdProofNumber = '';
    }

    // Reads a saved date back into the date picker's format.
    //
    // The server's date format is not guaranteed, and the previous version only
    // accepted dd/mm/yyyy - anything else was silently dropped, which left the
    // date box empty and made a saved minor fail validation on the next save.
    // This accepts the formats the API could realistically return.
    parseSavedDate(value: any): any {
        if (!value) {
            return '';
        }
        if (value instanceof Date && !isNaN(value.getTime())) {
            return { date: { year: value.getFullYear(), month: value.getMonth() + 1, day: value.getDate() } };
        }
        if (typeof value !== 'string') {
            return '';
        }
        const text = value.trim();
        if (!text) {
            return '';
        }
        // Drop any time part: "15/06/2010 00:00:00" or "2010-06-15T00:00:00".
        const datePart = text.split(' ')[0].split('T')[0];
        const parts = datePart.split(/[\/\-.]/);
        if (parts.length !== 3) {
            return '';
        }
        let day: number, month: number, year: number;
        if (parts[0].length === 4) {
            // yyyy-mm-dd
            year = parseInt(parts[0], 10);
            month = parseInt(parts[1], 10);
            day = parseInt(parts[2], 10);
        } else {
            // dd/mm/yyyy
            day = parseInt(parts[0], 10);
            month = parseInt(parts[1], 10);
            year = parseInt(parts[2], 10);
        }
        if (!day || !month || !year) {
            return '';
        }
        // A month above 12 can only mean the day and month arrived swapped
        // (mm/dd/yyyy). This never makes a valid date worse.
        if (month > 12 && day <= 12) {
            const swap = day;
            day = month;
            month = swap;
        }
        if (day < 1 || day > 31 || month < 1 || month > 12) {
            return '';
        }
        return { date: { year: year, month: month, day: day } };
    }

    public noWhitespaceValidator(control: FormControl) {
        return (control.value || '').trim().length? null : { 'whitespace': true };       
    }

    setCountryCode(event:any){
        const regex = /[^0-9]/g;
        const input = event.target.value;
        event.target.value = input.replace(regex, '');
        let a:any = this.nomineeForm.value.NomineeCountryCode?.split('-');
        this.countryCode = a[0];
    }

    noSpace(event: any){
        const pattern = new RegExp('^[-a-zA-Z0-9@._\b]+$');
        const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
        if (!pattern.test(key) && event.charCode !== 0) {
            event.preventDefault();
            return;
        }
    }

    // onInputChange(event:any){
    //     const pattern = new RegExp('^[a-zA-Z \b]+$');
    //     const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    //     if (!pattern.test(key) && event.charCode !== 0) {
    //         event.preventDefault();
    //         return;
    //     }
    // }
    onInputChange(event: any) {
        const pattern = /^[a-zA-Z \b]+$/;
        const inputText = event.target.value;
      
        if (!pattern.test(inputText)) {
          // Remove invalid characters from the input value
          event.target.value = inputText.replace(new RegExp(`[^a-zA-Z \b]+`, 'g'), '');
        }
      }
      
    spaceValidation(event:any, name: any){
        const input = event.target.value;
        event.target.value = input.replace(/^\s+|\s+$|\s+(?=\s)/g, "");
    }

    alphaNumeric(event: any){
        const pattern = new RegExp('^[a-zA-Z0-9\b]+$');
        const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
        if (!pattern.test(key) && event.charCode !== 0) {
            event.preventDefault();
            return;
        }
    }

    // onlyNumberKey(event: any) {
    //     const pattern = new RegExp('^[0-9\b]+$');
    //     const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    //     if (!pattern.test(key) && event.charCode !== 0) {
    //         event.preventDefault();
    //         return;
    //     }
    // }

    numericOnly(event: any) {
        const pattern = /^[0-9\b]+$/;
        const inputText = event.target.value;
      
        if (!pattern.test(inputText)) {
          // Remove non-numeric characters from the input value
          event.target.value = inputText.replace(new RegExp(`[^0-9]+`, 'g'), '');
        }
      }

    emitShare(i:any){
        this.data.shareValue =  this.nomineeForm.controls.NomineeShare.value;
        this.shareValue.emit({
            data:this.data,
            item: i
        });
    }
    deleteShare(i:any){
        this.data.shareValue = 100 - this.nomineeForm.controls.NomineeShare.value;
        this.data.totalShare = this.data.shareValue;
        if(this.data.totalShare !== 100) {
            this.data.add = true;
            this.data.item = i - 1;
        }
        this.shareValue.emit({
            data:this.data,
            item: i - 1,
            delete: i
        });
    }

    addNominee(){
        this.nomineeAdd.emit(this.data.item);
        if(this.data.item !== 1){
            this.delNominee = true;
        }
    }

    deleteNominee(){
        this.nomineeDelete.emit(this.indexvalue);
        if(this.data.item !== 1){
            this.delNominee = false;
        }
    }
    checkCode() {
        let c = '';
        if (this.countryCode) {
          c = this.countryCode.TeleCode;
        }
        let code = this.countryList.filter((e: any) => {
          return e.TeleCode === c;
        });
        this.nomineeValue.NomineeCountryCode = this.countryCode.TeleCode;
        let param = {
            index: this.indexvalue + 1,
            status: true,
            data: this.nomineeValue
        }
        this.nomineeFormValid.emit(param);
        if (!code || code.length === 0) {
          this.countryCodeError = true;
        } else {
          this.countryCodeError = false;
        }
      }
      telcode(event: any){
        if(event.length > 3){
          event = event.substring(0, event.length-1);
        }
        this.countryCode = event;
        this.nomineeValue.NomineeCountryCode = event;
        let param = {
            index: this.indexvalue + 1,
            status: true,
            data: this.nomineeValue
        }
        this.nomineeFormValid.emit(param);
      }
      restrictEnter(args: any) {
        if (args.key === "Enter" && args.keyCode == 13)
          args.preventDefault();
      }
      selectCodeEvent(event: any){
        this.countryCode =event.TeleCode;
        // this.nomineeForm.controls.NomineeCountryCode.setValue(event.TeleCode);
        this.nomineeValue.NomineeCountryCode = event.TeleCode;
        let param = {
            index: this.indexvalue + 1,
            status: true,
            data: this.nomineeValue
        }
        this.nomineeFormValid.emit(param);
    }
    emailOnly(event: any) {
        const pattern = /^[a-zA-Z0-9._@]+$/;
        const inputText = event.target.value;
        if (!pattern.test(inputText)) {
          event.target.value = inputText.replace(new RegExp(`[^a-zA-Z0-9._@]+`, 'g'), '');
        }
      }
}